import { render, staticRenderFns } from "./lostdataanalyse.vue?vue&type=template&id=c37b3d6e&scoped=true&"
import script from "./lostdataanalyse.vue?vue&type=script&lang=ts&"
export * from "./lostdataanalyse.vue?vue&type=script&lang=ts&"
import style0 from "./lostdataanalyse.vue?vue&type=style&index=0&id=c37b3d6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37b3d6e",
  null
  
)

export default component.exports